import VendorTable from "./VendorTable";

const Vendor = () => {
  return (
    <>
      <VendorTable />
    </>
  );
};

export default Vendor;
